// extracted by mini-css-extract-plugin
module.exports = {"svg":"avatar_svg_unbB8"};